import React, { Fragment } from "react";
import Steps from "@ADC/components/Pages/ServiceAreasLanders/Form/Steps";
import { StaticImage } from "gatsby-plugin-image";
import BBBCertified from "@ADC/components/Views/BBBCertified";

const Home = ({ heroSectionImage, heroSectionVideo, name, cityProsBadge }) => {
  return (
    <div className="relative w-full h-full">
      {cityProsBadge?.data ? (
        <div className="absolute top-[40px] max-md:left-1/2 max-md:-translate-x-1/2 md:top-4 md:right-[42%] largeTab:right-[35%] lg:right-[31%] xl:right-[37%] 1xl:right-[33%] 2xl:right-[30%] min-[2000px]:right-[40%] min-[2200px]:right-[42%] min-[2400px]:right-[46%] z-50 mx-auto">
          <img
            src={cityProsBadge.data.attributes.url}
            className="w-32 sm:w-40 md:w-52"
            alt="CityPros"
          />
        </div>
      ) : null}
      {heroSectionImage?.data ? (
        <img
          src={heroSectionImage.data.attributes.url}
          className="md:!hidden w-full h-full"
          alt={name}
        />
      ) : heroSectionVideo?.data ? (
        <Fragment>
          {/* For Mobile */}
          <video
            className="w-full h-auto black md:hidden"
            playsInline
            autoPlay
            muted
            loop
          >
            <source
              src={heroSectionVideo.data.attributes.url}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </Fragment>
      ) : (
        <StaticImage
          src="https://adc-dr-assets.s3.amazonaws.com/debtredemption/images/city-pages/hero-bg-mobile.webp"
          className="md:!hidden w-full h-full"
          alt={name}
        />
      )}

      <div className="grid md:grid-cols-[55%_45%] lg:grid-cols-[65%_35%] place-items-center">
        {heroSectionImage?.data ? (
          <img
            src={heroSectionImage.data.attributes.url}
            className="w-full h-full object-cover home-bg max-md:hidden"
            alt={name}
          />
        ) : heroSectionVideo?.data ? (
          <video
            className="w-full h-full black home-bg max-md:hidden object-cover"
            playsInline
            autoPlay
            muted
            loop
          >
            <source
              src={heroSectionVideo.data.attributes.url}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        ) : (
          <StaticImage
            src="https://adc-dr-assets.s3.amazonaws.com/debtredemption/images/city-pages/hero-bg.webp"
            className="max-md:!hidden w-full h-full home-bg object-cover object-[12%_center]"
            alt={name}
          />
        )}

        <div className="bg-white w-full h-full flex items-center">
          <div className="py-6 md:py-24 md:ps-0 md:pe-5 px-4 w-full lg:w-[30rem]">
            <Steps name={name} />
          </div>
        </div>
      </div>

      <BBBCertified />
    </div>
  );
};

export default Home;
